<script setup lang="ts">
/**
 * 根组件：只承载路由出口。
 *
 * 布局由各路由的 `component` 决定（模块页面用 `PortalLayout`，登录/404 独立），
 * 因此这里不引入任何布局，避免「根布局 + 路由布局」双层嵌套。
 */
</script>

<template>
  <RouterView />
</template>
